import { Component, OnInit, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { MaterialPageGrid } from '../../../utils/material-page-grid';
import { FormBuilder } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { PortalProductsService } from '../../../services/portal-products.service';
import { OpenDialog } from '../../../shared/dialogs/dialog';
import { ConfirmDialogComponent } from '../../../shared/dialogs/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-verification-codes',
  templateUrl: './verification-codes.component.html',
  styleUrls: ['./verification-codes.component.scss'],
})
export class VerificationCodesComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  resultsPageGrid: MaterialPageGrid;
  gridInProgress = false;
  dataList: any;
  displayedColumns: string[] = ['nic', 'emailData', 'mobileData', 'verificationData', 'actions'];

  constructor(private fb: FormBuilder, private portalProductsService: PortalProductsService) {}

  ngOnInit() {
    this.initGrid();
  }

  async initGrid() {
    this.resultsPageGrid = new MaterialPageGrid(this.fb, 15)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery) => {
        try {
          this.gridInProgress = true;
          this.dataList = await this.portalProductsService.getVerificationCodes(
            listQuery.filterValues.searchUsers,
            listQuery.pageIndex,
            listQuery.pageSize
          );
          this.gridInProgress = false;

          return {
            data: this.dataList.values || [],
            total: this.dataList.count || 0,
          };
        } catch (error) {
          this.gridInProgress = false;
          return { data: [], total: 0 };
        }
      })
      .setFilters({
        searchUsers: '',
      });

    // Attach sort and paginator after view init
    setTimeout(() => {
      if (this.sort) {
        this.resultsPageGrid.attachSort(this.sort);
      }
      if (this.paginator) {
        this.resultsPageGrid.attachPaginator(this.paginator);
      }
    });
  }

  async deleteVerificationCode(codeId) {
    OpenDialog(ConfirmDialogComponent, {
      title: 'Delete Confirmation!',
      content: 'Do you want to delete the selected item?',
      okText: 'Delete',
      cancelText: 'Cancel',
    })
      .then(async (r) => {
        try {
          await this.portalProductsService.deleteVerificationCode(codeId);
          this.initGrid();
        } catch (e) {}
      })
      .catch(() => {
        return;
      });
  }

  refreshDataList() {
    this.resultsPageGrid.forceRefresh();
  }
}
